module.exports = __webpack_public_path__ + "static/media/16UNODC29.bf0b515b.jpg";